import ConfirmPopup from '~/components/shared/ConfirmPopup';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { IUser } from '~/models';
import { pluralize } from '~/utils/String';

interface IInviteSuccessViewProps {
  professional: IUser | null;
  selectedCount: number;
  onClose: () => void;
}

export const InviteSuccessView = ({
  professional,
  selectedCount,
  onClose,
}: IInviteSuccessViewProps) => (
  <ConfirmPopup
    Icon={() => <AnimatedCheckCircle />}
    title={selectedCount === 1 ? 'Invite Successfully Sent!' : 'Invites Successfully Sent!'}
    titleStyle={{ marginTop: 21, marginBottom: 16 }}
    description={
      <Typography as="span" color={colors.neutral[500]}>
        <strong>{professional?.full_name}</strong> has been invited to the selected{' '}
        {pluralize('interview', selectedCount)}. Once they accept at the listed rate,{' '}
        {professional?.first_name} will be confirmed!
      </Typography>
    }
    descriptionStyle={{ width: '100%', marginBottom: 38 }}
    modalStyle={{ width: 560 }}
    rightButtonText="Close"
    rightButtonAction={onClose}
  />
);
